import React from 'react'

import { useToggle } from 'usehooks-ts'

import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { useUpdateCandidate } from 'modules/ats/hooks/candidates/useUpdateCandidate'

export interface TalentPoolTogglerCandidate {
  id: number
  talentPool?: boolean | null
  consentToTalentPool?: boolean | null
}

export const useTalentPoolToggler = (candidate: TalentPoolTogglerCandidate) => {
  const [showTalentPoolModal, toggleShowTalentPoolModal] = useToggle(false)
  const [rememberConfirmationCheckbox, setRememberConfirmationCheckbox] = React.useState(false)
  const { updateCandidate } = useUpdateCandidate(candidate)
  const talentPool = candidate.talentPool

  const updateCandidateTalentPoolValue = async () => {
    const { success } = await asyncAction(() => updateCandidate({ talentPool: !talentPool }), {
      successMessage: talentPool
        ? i18n.t('common.removed_successfully')
        : i18n.t('common.saved_successfully'),
    })
    if (!talentPool) {
      track(trackingEvents.ats.addCandidateToTalentPool, {
        is_successful: success,
      })
    }
  }

  async function onTalentPoolModalSubmit() {
    await updateCandidateTalentPoolValue()
    toggleShowTalentPoolModal()

    if (rememberConfirmationCheckbox) {
      SafeLocalStorage.setItem('factorial:talentPoolConsentMessage', true)
    }
  }

  const showTalentModalFunction = () => {
    const consentGiven = candidate?.consentToTalentPool
    const dontShowMessage = SafeLocalStorage.getItem(
      'factorial:talentPoolConsentMessage',
      JSON.parse
    )

    if (consentGiven || dontShowMessage) {
      updateCandidateTalentPoolValue()
    } else {
      toggleShowTalentPoolModal()
    }
  }

  return {
    showTalentModalFunction,
    updateCandidateTalentPoolValue,
    onTalentPoolModalSubmit,
    showTalentPoolModal,
    toggleShowTalentPoolModal,
    rememberConfirmationCheckbox,
    setRememberConfirmationCheckbox,
  }
}
